/**
 * Overlay visual de cantidad sugerida para productos bajo pedido con stock negativo.
 * No modifica SuggestedQuantity en backend; solo ajusta la fila mostrada.
 */
export function overlayOnDemandNegativeStockSuggested<T extends {
  on_demand?: boolean;
  stock_actual?: number;
  cantidad_sugerida_sistema?: number;
  cantidad_sugerida_sistema_base?: number;
  last_purchase_price?: number;
  suggested_line_total?: number;
  available_suppliers?: Array<{
    cantidad_sugerida_base?: number;
    cantidad_sugerida_ajustada?: number;
  }>;
}>(product: T, enabled: boolean): T {
  if (!enabled || !product.on_demand) return product;
  const stock = Number(product.stock_actual ?? 0);
  if (!Number.isFinite(stock) || stock >= 0) return product;
  const persisted = Number(
    product.cantidad_sugerida_sistema_base ?? product.cantidad_sugerida_sistema ?? 0,
  );
  if (persisted > 0) return product;

  const qty = Math.abs(stock);
  const suppliers = (product.available_suppliers ?? []).map((supplier) => {
    const supplierBase = Number(supplier.cantidad_sugerida_base ?? 0);
    if (supplierBase > 0) return supplier;
    return {
      ...supplier,
      cantidad_sugerida_base: qty,
      cantidad_sugerida_ajustada: qty,
    };
  });

  return {
    ...product,
    cantidad_sugerida_sistema_base: qty,
    cantidad_sugerida_sistema: qty,
    suggested_line_total: qty * Number(product.last_purchase_price || 0),
    available_suppliers: suppliers,
  };
}

export function overlayOnDemandNegativeStockSuggestedRows<T extends {
  on_demand?: boolean;
  stock_actual?: number;
  cantidad_sugerida_sistema?: number;
  cantidad_sugerida_sistema_base?: number;
}>(rows: T[], enabled: boolean): T[] {
  if (!enabled) return rows;
  return rows.map((row) => overlayOnDemandNegativeStockSuggested(row, enabled));
}
